import React, { useContext, useEffect, useRef, useState } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '../state/Context';
import { Loader } from '../components/common';
import { useInterceptors } from '../network/apiClient';

/**
 * Users must sign in to view children of this route.
 * @returns {import('react').FunctionComponent} React element that enforces authentication.
 */
function ProtectedRoute() {
  const { tokens, setTokens } = useContext(AuthContext);
  const ref = useRef(tokens);
  useEffect(() => {
    ref.current = tokens;
  }, [tokens]);

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (
      !tokens ||
      !tokens.accessToken ||
      !tokens.idToken ||
      !tokens.refreshToken
    ) {
      setReady(true);
      return;
    }
    useInterceptors(
      () => ref.current,
      (tokens) => {
        ref.current = tokens;
        setTokens(tokens);
      },
    );
    setReady(true);
  }, [tokens]);

  return ready ? (
    tokens.accessToken && tokens.refreshToken ? (
      <Outlet />
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Loader />
  );
}

export default ProtectedRoute;
